// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FuneraryQuoteController from "./funerary_quote_controller"
application.register("funerary-quote", FuneraryQuoteController)

import AcceptanceTermFormController from "./acceptance_term_form_controller"
application.register("acceptance-term-form", AcceptanceTermFormController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdicionalsController from "./adicionals_controller"
application.register("adicionals", AdicionalsController)

import AdminAcceptanceTermFormController from "./admin_acceptance_term_form_controller"
application.register("admin-acceptance-term-form", AdminAcceptanceTermFormController)

import AdminDoubtSearchController from "./admin_doubt_search_controller"
application.register("admin-doubt-search", AdminDoubtSearchController)

import BackButtonController from "./back_button_controller"
application.register("back-button", BackButtonController)

import BeneficiariesController from "./beneficiaries_controller"
application.register("beneficiaries", BeneficiariesController)

import BeneficiariesQuantityController from "./beneficiaries_quantity_controller"
application.register("beneficiaries-quantity", BeneficiariesQuantityController)

import BillingAddressCardsController from "./billing_address_cards_controller"
application.register("billing-address-cards", BillingAddressCardsController)

import BillingAddressManagerController from "./billing_address_manager_controller"
application.register("billing-address-manager", BillingAddressManagerController)

import BillingAddressSelectorController from "./billing_address_selector_controller"
application.register("billing-address-selector", BillingAddressSelectorController)

import BillingAddressToggleController from "./billing_address_toggle_controller"
application.register("billing-address-toggle", BillingAddressToggleController)

import BulkApprovalController from "./bulk_approval_controller"
application.register("bulk-approval", BulkApprovalController)

import CancelDirectSaleController from "./cancel_direct_sale_controller"
application.register("cancel-direct-sale", CancelDirectSaleController)

import CardFormController from "./card_form_controller"
application.register("card-form", CardFormController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CepLookupController from "./cep_lookup_controller"
application.register("cep-lookup", CepLookupController)

import ChargeMomentController from "./charge_moment_controller"
application.register("charge-moment", ChargeMomentController)

import ChatLauncherController from "./chat_launcher_controller"
application.register("chat-launcher", ChatLauncherController)

import CheckoutFormController from "./checkout_form_controller"
application.register("checkout-form", CheckoutFormController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import ContactRowController from "./contact_row_controller"
application.register("contact-row", ContactRowController)

import ContractModalController from "./contract_modal_controller"
application.register("contract-modal", ContractModalController)

import CopyPaymentSlipModalController from "./copy_payment_slip_modal_controller"
application.register("copy-payment-slip-modal", CopyPaymentSlipModalController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import CpfValidationController from "./cpf_validation_controller"
application.register("cpf-validation", CpfValidationController)

import CsvExportController from "./csv_export_controller"
application.register("csv-export", CsvExportController)

import CustomerDocumentController from "./customer_document_controller"
application.register("customer-document", CustomerDocumentController)

import DataEditController from "./data_edit_controller"
application.register("data-edit", DataEditController)

import DatePresetController from "./date_preset_controller"
application.register("date-preset", DatePresetController)

import DevSwitcherController from "./dev_switcher_controller"
application.register("dev-switcher", DevSwitcherController)

import DigitOnlyInputController from "./digit_only_input_controller"
application.register("digit-only-input", DigitOnlyInputController)

import DirectSaleSplitPaymentController from "./direct_sale_split_payment_controller"
application.register("direct-sale-split-payment", DirectSaleSplitPaymentController)

import DiscountLimitsController from "./discount_limits_controller"
application.register("discount-limits", DiscountLimitsController)

import DoubtSearchController from "./doubt_search_controller"
application.register("doubt-search", DoubtSearchController)

import FilePickerController from "./file_picker_controller"
application.register("file-picker", FilePickerController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FileUploadProgressController from "./file_upload_progress_controller"
application.register("file-upload-progress", FileUploadProgressController)

import FormAutosaveController from "./form_autosave_controller"
application.register("form-autosave", FormAutosaveController)

import FormValidationTooltipController from "./form_validation_tooltip_controller"
application.register("form-validation-tooltip", FormValidationTooltipController)

import FuneraryAdicionalsController from "./funerary_adicionals_controller"
application.register("funerary-adicionals", FuneraryAdicionalsController)

import FuneraryPlanFormController from "./funerary_plan_form_controller"
application.register("funerary-plan-form", FuneraryPlanFormController)

import FuneraryPlanItemsController from "./funerary_plan_items_controller"
application.register("funerary-plan-items", FuneraryPlanItemsController)

import GalleryModalController from "./gallery_modal_controller"
application.register("gallery-modal", GalleryModalController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HierarchyController from "./hierarchy_controller"
application.register("hierarchy", HierarchyController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InlineAddressFormController from "./inline_address_form_controller"
application.register("inline-address-form", InlineAddressFormController)

import LazyMapController from "./lazy_map_controller"
application.register("lazy-map", LazyMapController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import MenuDropdownController from "./menu_dropdown_controller"
application.register("menu-dropdown", MenuDropdownController)

import MultipleImagePreviewController from "./multiple_image_preview_controller"
application.register("multiple-image-preview", MultipleImagePreviewController)

import NestedRowsController from "./nested_rows_controller"
application.register("nested-rows", NestedRowsController)
import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import ObituaryController from "./obituary_controller"
application.register("obituary", ObituaryController)

import OrganizeListController from "./organize_list_controller"
application.register("organize-list", OrganizeListController)

import PartnerSaleLinkFormController from "./partner_sale_link_form_controller"
application.register("partner-sale-link-form", PartnerSaleLinkFormController)

import PartnerSplitPaymentController from "./partner_split_payment_controller"
application.register("partner-split-payment", PartnerSplitPaymentController)

import PaymentFieldsController from "./payment_fields_controller"
application.register("payment-fields", PaymentFieldsController)

import PaymentTendersController from "./payment_tenders_controller"
application.register("payment-tenders", PaymentTendersController)

import PersonNameInputController from "./person_name_input_controller"
application.register("person-name-input", PersonNameInputController)

import PixCountdownController from "./pix_countdown_controller"
application.register("pix-countdown", PixCountdownController)

import PixPaymentStatusController from "./pix_payment_status_controller"
application.register("pix-payment-status", PixPaymentStatusController)

import PrefillController from "./prefill_controller"
application.register("prefill", PrefillController)

import PrepareFormController from "./prepare_form_controller"
application.register("prepare-form", PrepareFormController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import ProcessingOverlayController from "./processing_overlay_controller"
application.register("processing-overlay", ProcessingOverlayController)

import ProductController from "./product_controller"
application.register("product", ProductController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import ProtheusSellerRuleFormController from "./protheus_seller_rule_form_controller"
application.register("protheus-seller-rule-form", ProtheusSellerRuleFormController)

import RecaptchaFallbackController from "./recaptcha_fallback_controller"
application.register("recaptcha-fallback", RecaptchaFallbackController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SearchableSelectsController from "./searchable_selects_controller"
application.register("searchable-selects", SearchableSelectsController)

import SellerCodeController from "./seller_code_controller"
application.register("seller-code", SellerCodeController)

import SidebarDropdownController from "./sidebar_dropdown_controller"
application.register("sidebar-dropdown", SidebarDropdownController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SlideDrawerController from "./slide_drawer_controller"
application.register("slide-drawer", SlideDrawerController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import SplitPaymentController from "./split_payment_controller"
application.register("split-payment", SplitPaymentController)

import StageClosingController from "./stage_closing_controller"
application.register("stage-closing", StageClosingController)

import StateCityController from "./state_city_controller"
application.register("state-city", StateCityController)

import TabsProductShowController from "./tabs_product_show_controller"
application.register("tabs-product-show", TabsProductShowController)

import TaskChecklistController from "./task_checklist_controller"
application.register("task-checklist", TaskChecklistController)

import TeamGoalsController from "./team_goals_controller"
application.register("team-goals", TeamGoalsController)

import ThreedsPollerController from "./threeds_poller_controller"
application.register("threeds-poller", ThreedsPollerController)

import FuneraryInlineController from "./funerary_inline_controller"
application.register("funerary-inline", FuneraryInlineController)

import SalesDashboardController from "./sales_dashboard_controller"
application.register("sales-dashboard", SalesDashboardController)

import SalesDashboardChartController from "./sales_dashboard_chart_controller"
application.register("sales-dashboard-chart", SalesDashboardChartController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)
